module.exports = __webpack_public_path__ + "img/그룹 4195.e0c86e89.png";